import { TrackingHandler } from './TrackingHandler';
const logStart = typeof window.lgStart === 'number' ? window.lgStart : new Date().getTime();
let lastLogTime = logStart;
const sendLog = (data) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', window.endpoints.logger);
    xhr.responseType = 'json';
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
};
export const log = async (type, data = {}) => {
    const trackingHandler = TrackingHandler.getInstance();
    await trackingHandler.initialized;
    const timestamp = new Date().getTime();
    data.pageType = window.page.type || 'unknown';
    data.pageVersion = window.page.version || 'unknown';
    if (Object.entries(trackingHandler.experimentVariations).length > 0) {
        data.experimentVariations = trackingHandler.experimentVariations;
    }
    let externalReferrer = null;
    if (document.referrer) {
        const externalReferrerUrl = new URL(document.referrer);
        if (window.location.hostname !== externalReferrerUrl.hostname) {
            externalReferrer = externalReferrerUrl.toString();
        }
    }
    const logData = {
        vt: trackingHandler.visitorId || 'unknown',
        vs: trackingHandler.visitId || 'unknown',
        v: trackingHandler.viewId || 'unknown',
        f: trackingHandler.fingerprint,
        u: window.location.toString(),
        ty: type,
        d: data,
        ti: timestamp,
        sl: timestamp - logStart,
        sp: timestamp - lastLogTime,
        r: document.referrer || '',
        er: externalReferrer,
    };
    lastLogTime = timestamp;
    if (trackingHandler.isInternalTest) {
        console.log('Internal test mode, skipping sending log', logData);
        return;
    }
    sendLog(logData);
};
